import axios from 'axios';
import { createLabLockQuery } from './queries';

const putLabLockDetails = async ({ is_locked, startDate, endDate, comment } = {}) => {
    const query = createLabLockQuery({ is_locked, startDate, endDate, comment });
    const { data } = await axios.put(query.url, { ...query.body });
    return data;
};

export default putLabLockDetails;
